import { useGetUserGroupsSuspense } from "api/generated/user-groups/user-groups";

export const useAllUserGroupsQuery = () =>
    useGetUserGroupsSuspense(
        { format: "WithUsers" },
        {
            query: {
                select: (response) => {
                    if (response.data.type !== "WithUsers") {
                        throw new Error("Expected WithUsers response type");
                    }
                    return response.data.data.content.map(
                        (dto) => dto.resource
                    );
                },
                staleTime: 30 * 1000,
            },
        }
    );
